import * as React from "react";
import ReactDOM from "react-dom";
import Notification from "./Notification";

export class NotificationManager {
  constructor() {
    const body = document.getElementsByTagName("body")[0];
    const notificationContainer = document.createElement("div");
    notificationContainer.id = "notification-container-main";
    body.insertAdjacentElement("beforeend", notificationContainer);
    this.containerRef = notificationContainer;
  }

  show(options) {
    const notificationId = Math.random().toString(36).substr(2, 9);
    const notification = {
      id: notificationId,
      ...options,
      destroy: () => this.destroy(options.id ?? notificationId),
    };

    this.notifications = this.notifications?.length ? [notification, ...this.notifications] : [notification];
    this.render();
  }

  destroy(id) {
    this.notifications = this.notifications.filter(notification => notification.id !== id);
    this.render();
  }

  render() {
    const notificationsList = this.notifications.map((notificationProps) => (
      <Notification key={notificationProps.id} {...notificationProps} />
    ));
    ReactDOM.render(notificationsList, this.containerRef);
  }
}

export const notificationManager = new NotificationManager();
